import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Collapse, Row
} from 'reactstrap';

import {
  trackEvent,
  TRACKS_THIRD_ARM,
} from 'src/util/segment-storeless';

import TrackedLink from 'src/components/TrackedLink';
import TipBox from 'src/components/TipBox';
import { isTestOrDev } from 'src/util/environment';
import ToggleStep from './ToggleStep';
import styles from './style.module.css';

const ScheduleStep = (props) => {
  const { isComplete, getSegmentProps } = props;
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    if (!isOpen && isComplete) {
      trackEvent(
        TRACKS_THIRD_ARM.see_step_again,
        getSegmentProps({
          step_name: 'schedule'
        })
      );
    }
    setIsOpen(!isOpen);
  };
  const collapseStyles = isOpen ? styles.stepCollapse : null;

  const SchedulesTip = () => (
    <TipBox>
      <strong>Pro Tip: </strong>
      Once you create your first schedule, make sure to link it to an Escalation Policy
      so that the appropriate responder is notified when incidents occur.
    </TipBox>
  );

  const schedulesVideo = () => {
    if (isTestOrDev()) {
      return (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video controls src="" />
      );
    }
    /* Schedules video in an Iframe using Wistia's code implementation */
    return (
      <div className="wistia_responsive_padding" style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
        <div
          className="wistia_responsive_wrapper"
          style={{
            height: '100%', left: '0', position: 'absolute', top: '0', width: '100%'
          }}
        >
          <iframe
            src="https://fast.wistia.net/embed/iframe/koganv6icc?videoFoam=true"
            title="Schedules - Onboarding clip Video"
            allow="autoplay; fullscreen"
            allowtransparency="true"
            frameBorder="0"
            scrolling="no"
            className="wistia_embed"
            name="wistia_embed"
            allowFullScreen
            msallowfullscreen="true"
            width="100%"
            height="100%"
          />
        </div>
        <script src="https://fast.wistia.net/assets/external/E-v1.js" async />
      </div>
    );
  };

  return (
    <div>
      <div>
        <ToggleStep
          isOpen={isOpen}
          toggle={toggle}
          stepNumber="4"
          stepTitle="Create your first on-call schedule & add your team!"
          isCompleted={isComplete}
        />
        <Collapse className={collapseStyles} isOpen={isOpen} data-test="onboarding-schedule-step-toggle">
          <Row className="pb-1">
            <Col>
              <p>
                On-call schedules are used to map out your coverage needs, and determine who will be
                notified when an incident is triggered.
              </p>
              <p>Check out this video to walk you through schedules.</p>
              <TrackedLink
                className="btn btn-primary btn-sm"
                href="/schedules#new"
                data-test="create-schedule"
                trackName={TRACKS_THIRD_ARM.schedule_link}
                trackProperties={getSegmentProps()}
              >
                Create my first schedule!
              </TrackedLink>
            </Col>
            <Col>
              {schedulesVideo()}
            </Col>
          </Row>
          <SchedulesTip />
        </Collapse>
      </div>
    </div>
  );
};

ScheduleStep.propTypes = {
  isComplete: PropTypes.bool.isRequired,
  getSegmentProps: PropTypes.func.isRequired,
};

export default ScheduleStep;
